import {generateUniqueTemplateKey} from './gtmHelpers';

interface EventParams {
  [key: string]: any;
}

const sendEventToGA4 = (eventName: string, eventParams: EventParams) => {
  if (process.env.ENVIRONMENT !== 'local') {
    const {template} = generateUniqueTemplateKey(document.location.pathname);
    // Check if param 'content_group' already exists
    // For 'page_view' it is necessary that 'content_group' is already set, because the events are not immediately sent
    // For 'page_view' and 'search' document.location.pathname could have changed already
    const params = eventParams.content_group ? eventParams : {...eventParams, content_group: template};

    if (eventName === 'page_view') {
      // @ts-ignore
      gtag('get', process.env.REACT_APP_GTAG_ID, 'user_properties', (up) => {
        // @ts-ignore
        gtag('event', eventName, {...params, fupa_region_property: up?.fupa_region});
      });
    } else {
      // @ts-ignore
      gtag('event', eventName, params);
    }
  }
};

const setDimensionToGA4 = (paramValuePair: any) => {
  if (process.env.ENVIRONMENT !== 'local') {
    // @ts-ignore
    gtag('set', paramValuePair);
  }
};

export {sendEventToGA4, setDimensionToGA4};
